import axios from "../api";

export const createWhitelistIpAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/whitelist-ips/create", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const editWhiteListIpAction = async (id, data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/whitelist-ips/ipUpdate/${id}`, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const getWhitelistIpByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/whitelist-ips/getWhitelistIpById/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const getAllWhiteListIpsAction = async (currentPage, searchValue, pageSize, byUser, id, merchantId) => {
  let apiUrl = `/api/whitelist-ips/getall?page=${currentPage}&searchValue=${searchValue}&pageSize=${pageSize}`;
  if (byUser) {
    apiUrl += `&byUser=${byUser}`;
  }
  if (id) {
    apiUrl += `&id=${id}`;
  }
  if (merchantId) {
    apiUrl += `&merchantId=${merchantId}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteSingleMultipleBusinessAction = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/whitelist-ips/singleMultipleDelete`, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const checkWhitelistRestrictionAction = async (ip = null) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/whitelist-ips/checkAccess`, { ip })
      .then((response) => {
        resolve(response.data?.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const getCurrentUserIpAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/whitelist-ips/getIp`)
      .then((response) => {
        resolve(response?.data?.data?.ip || null);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};
